
import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { selectOfferInitStepDefinition } from "./Steps/SelectOfferPageInitStep";
import { selectOfferPageStepDefinition } from "./Steps/SelectOfferPageStep";
import { SelectOfferTransition } from "./Transition/SelectOfferTransition";

export const selectOfferStartupFlow = new FlowDefinition("SelectOfferFlow");

selectOfferStartupFlow.addStep(selectOfferInitStepDefinition);
selectOfferStartupFlow.addStep(selectOfferPageStepDefinition);

selectOfferStartupFlow.addLink("SelectOfferInit_Step", "SelectOffer_Step");

selectOfferStartupFlow.addTransition(SelectOfferTransition, "SelectOfferInit_Step");

selectOfferStartupFlow.setStartStep("SelectOfferInit_Step");

export const selectOfferStepDefinition = new StepDefinition({
    stepName: "SelectOfferFlow",
    stepFlow: selectOfferStartupFlow,
    contextIsolation: false
})